// Feature selectors
export const dashboardEnabled = ({ features = [] }: { features: string[] }) =>
  features.indexOf('dashboard') >= 0

export const assetManagementEnabled = ({ features = [] }: { features: string[] }) =>
  features.indexOf('assetManagement') >= 0

export const hotelingEnabled = ({ features = [] }: { features: string[] }) =>
  features.indexOf('hoteling') >= 0

export const leasesEnabled = ({ features = [] }: { features: string[] }) =>
  features.indexOf('lease') >= 0

export const kioskWayfinderEnabled = ({ features = [] }: { features: string[] }) =>
  features.indexOf('kioskWayfinder') >= 0

export const meetingRoomBookingEnabled = ({ features = [] }: { features: string[] }) =>
  features.indexOf('meetingRoomBooking') >= 0

export const issueReportingEnabled = ({ features = [] }: { features: string[] }) =>
  features.indexOf('issueReporting') >= 0

export const printingEnabled = ({ features = [] }: { features: string[] }) =>
  features.indexOf('printing') >= 0

export const spacePlanningFutureEnabled = ({ features = [] }: { features: string[] }) =>
  features.indexOf('spacePlanningFuture') >= 0

export const neighborhoodsEnabled = ({ features = [] }: { features: string[] }) =>
  features.indexOf('neighborhood') >= 0

export const selfMoveEnabled = ({ features = [] }: { features: string[] }) =>
  features.indexOf('selfMove') >= 0

export const secondarySeatEnabled = ({ features = [] }: { features: string[] }) =>
  features.indexOf('secondarySeat') >= 0

export const projectionEnabled = ({ features = [] }: { features: string[] }) =>
  features.indexOf('projection') >= 0

export const projectionLevel2Enabled = ({ features = [] }: { features: string[] }) =>
  features.indexOf('projection_level_2') >= 0

export const projectionLevel3Enabled = ({ features = [] }: { features: string[] }) =>
  features.indexOf('projection_level_3') >= 0

export const projectionLevel4Enabled = ({ features = [] }: { features: string[] }) =>
  features.indexOf('projection_level_4') >= 0

export const stackingEnabled = ({ features = [] }: { features: string[] }) =>
  features.indexOf('stacking') >= 0

export const operationCostEnabled = ({ features = [] }: { features: string[] }) =>
  features.indexOf('operational_cost') >= 0

export const autostackingEnabled = ({ features = [] }: { features: string[] }) =>
  features.indexOf('autostacking') >= 0
